/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Comm_SuppressionsInputs */

const cs_clients_comm_suppressions = /** @type {(inputs: Clients_Comm_SuppressionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blokace (suppression)`)
};

const en_clients_comm_suppressions = /** @type {(inputs: Clients_Comm_SuppressionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppressions`)
};

/**
* | output |
* | --- |
* | "Suppressions" |
*
* @param {Clients_Comm_SuppressionsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_comm_suppressions = /** @type {((inputs?: Clients_Comm_SuppressionsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Comm_SuppressionsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_comm_suppressions(inputs)
	return cs_clients_comm_suppressions(inputs)
});